/* eslint-disable */
const formValidation = {
        rules: {
            required: value => (value !== '' && value !== null && value !== undefined) || 'Fied required.',
            numeric: value => !!value && !/\D/.test(value) || 'invalid numeric',
            email: value => {
                const regx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return regx.test(value) || 'Invalid email address'; 
            },
            url: value => {
                const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
                    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
                    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
                    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator

                    return pattern.test(value) || "Invalid URL"
            },
            max: (value, max) => (!value || value.length <= max) || `Maximum character is ${max}`,
            min: (value, max) => (!value || value.length >= max) || `Minimum character is ${max}`,
        }
};

export default formValidation;